import React from "react";
import { MuiRhfTextField } from "../../shared/components/forms/MuiRhfTextField";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function ContactPersonForm(props: {
  disabled: boolean,
}) {
  const { t } = useTranslation();

  const stdFieldProps = {
    variant: "outlined" as "outlined",
    fullWidth: true,
    required: false,
    disabled: props.disabled,
    InputLabelProps: {
      shrink: true,
    },
  };

  return (
    <>
      <Typography variant={'h4'}>{t('Company.titleContactPerson') + ':'}</Typography>
      <Grid container={true} spacing={3} sx={{ marginTop: 2 }}>
        <Grid item={true} xs={12} lg={2}>
          <MuiRhfTextField name={'contactPerson.title'}
                           label={t('User.labelTitle')}
                           {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={12} lg={5}>
          <MuiRhfTextField name={'contactPerson.firstName'}
                           label={t('User.firstName')}
                           {...stdFieldProps} />
        </Grid>
        <Grid item={true} xs={12} lg={5}>
          <MuiRhfTextField name={'contactPerson.lastName'}
                           label={t('User.lastName')}
                           {...stdFieldProps} />
        </Grid>
        <Grid item={true} xs={12} lg={3}>
          <MuiRhfTextField name={'contactPerson.phone'}
                           label={t('User.phone')}
                           {...stdFieldProps}
          />
        </Grid>
        <Grid item={true} xs={12} lg={9}>
          <MuiRhfTextField name={'contactPerson.email'}
                           label={t('User.email')}
                           {...stdFieldProps}
          />
        </Grid>
      </Grid>
    </>
  )
}
